import { createFileRoute } from '@tanstack/react-router'

import WriteAdminProvinsiPage from '@/components/pages/backoffice/_user/_provinsi/containers/WriteAdminProvinsi'

export const Route = createFileRoute('/_backoffice/user/provinsi/create')({
  component: WriteAdminProvinsiPage
})
